<div class="side-bar">
  <app-calculator-process [isActive]="currentSection === 'data'" title="Datos"
                          imgUrl="assets/img/contact-form.png" (click)="goToSection('data', $event.target)"></app-calculator-process>
  <app-calculator-process [isActive]="currentSection === 'assumptions'" title="Supuestos"
                          imgUrl="assets/img/statistics-lens.png"
                          (click)="goToSection('assumptions', $event.target)"></app-calculator-process>
  <app-calculator-process [isActive]="currentSection === 'results'" title="Resultados"
                          imgUrl="assets/img/statistics.png" (click)="goToSection('results', $event.target)"></app-calculator-process>
</div>

<div class="main-section">
  <div *ngIf="currentSection === 'data'">
    <h2 class="main-title">Marque las tecnologías que le interese comparar y complete los datos</h2>

    <!--    <form class="selection-form" [formGroup]="truckSelectionForm" (ngSubmit)="onSubmit('assumptions')">-->
    <form class="selection-form" [formGroup]="truckSelectionForm">
      <section class="truck-section diesel-section">

        <div [ngClass]="['heading-wrapper', 'diesel-wrapper', toggleForm.dieselForm ? 'show-form' : 'hide-form']">
          <h3 class="section-title diesel-title">Camión a combustión interna</h3>
          <input class="checkbox-input disable-events" type="checkbox" formControlName="dieselForm"
                 id="diesel-checkbox">
          <span class="span-event-container" (click)="handleFormToggle('dieselForm')">
            <span class="arrow-form"></span>
          </span>
        </div>

        <form class="diesel-form truck-form" [formGroup]="dieselTruckForm">

          <div class="truck-form-column">
            <h4>Camión</h4>
            <div class="entry">
              <label data-required for="gross-weight">Peso bruto</label>
              <div class="input-container">
                <input type="number" formControlName="grossWeight" id="gross-weight">
                <span class="suffix">ton</span>
              </div>
            </div>
            <div class="entry">
              <label data-required for="tare">Tara</label>
              <div class="input-container">
                <input type="number" formControlName="tare" id="tare" required>
                <span class="suffix">ton</span>
              </div>
            </div>
            <div class="entry">
              <label data-required for="vehicle-change">Cambio flota</label>
              <div class="input-container">
                <input type="number" formControlName="vehicleChange" id="vehicle-change">
                <span class="suffix">años</span>
              </div>
            </div>
          </div>


          <div class="truck-form-column">
            <h4>Operación</h4>
            <div class="entry">
              <label data-required for="daily-distance">Kilómetros diarios</label>
              <div class="input-container">
                <input type="number" formControlName="dailyDistance" id="daily-distance">
                <span class="suffix">km/día</span>
              </div>
            </div>
            <div class="entry">
              <label [class.required]="!dieselTruckForm.get('performanceSwitch')?.value"
                     for="performance">Rendimiento</label>
              <div class="input-container">
                <input type="number" formControlName="performance" id="performance">
                <span class="suffix">km/lt</span>
              </div>
              <div class="required-checkbox-container">
                <input type="checkbox" formControlName="performanceSwitch" id="performance-available">
                <label for="performance-available">No disponible</label>
              </div>
            </div>
            <div class="entry">
              <label [class.required]="!dieselTruckForm.get('averageSpeedSwitch')?.value" for="average-speed">Velocidad
                media</label>
              <div class="input-container">
                <input type="number" formControlName="averageSpeed" id="average-speed">
                <span class="suffix">km/h</span>
              </div>
              <div class="required-checkbox-container">
                <input type="checkbox" formControlName="averageSpeedSwitch" id="average-speed-available">
                <label for="average-speed-available">No disponible</label>
              </div>
            </div>
            <div class="entry">
              <label data-required for="transport">Transporte</label>
              <div class="select">
                <select formControlName="transport" id="transport">
                  <option value="urban">Urbano</option>
                  <option value="regional">Regional</option>
                  <option value="longDistance">Larga distancia</option>
                </select>
              </div>
            </div>
            <div class="entry">
              <label data-required for="operating-days">Días operativos</label>
              <div class="input-container">
                <input type="number" formControlName="operatingDays" id="operating-days">
                <span class="suffix">días</span>
              </div>
            </div>
          </div>

          <div class="truck-form-column">
            <h4>Economía</h4>
            <div class="entry">
              <label data-required for="gas-cost">Costo gasoil</label>
              <div class="input-container">
                <input type="number" formControlName="gasCost" id="gas-cost">
                <span class="suffix">$/lt</span>
              </div>
            </div>
            <div class="entry">
              <label [class.required]="!dieselTruckForm.get('maintenanceCostSwitch')?.value" for="maintenance-cost">Costo
                mantenimiento</label>
              <div class="input-container">
                <input type="number" formControlName="maintenanceCost" id="maintenance-cost">
                <span class="suffix">USD/año</span>
              </div>
              <div class="required-checkbox-container">
                <input type="checkbox" formControlName="maintenanceCostSwitch" id="maintenance-cost-available">
                <label for="maintenance-cost-available">No disponible</label>
              </div>
            </div>
            <div class="entry">
              <label [class.required]="!dieselTruckForm.get('insuranceCostSwitch')?.value" for="insurance-cost">Costo
                seguro</label>
              <div class="input-container">
                <input type="number" formControlName="insuranceCost" id="insurance-cost">
                <span class="suffix">$/año</span>
              </div>
              <div class="required-checkbox-container">
                <input type="checkbox" formControlName="insuranceCostSwitch" id="insurance-cost-available">
                <label for="insurance-cost-available">No disponible</label>
              </div>
            </div>
            <div class="entry">
              <label data-required for="truck-price">Precio camión</label>
              <div class="input-container">
                <input type="number" formControlName="truckPrice" id="truck-price">
                <span class="suffix">USD</span>
              </div>
            </div>
          </div>
        </form>
      </section>

      <section class="truck-section electric-section">

        <div [ngClass]="['heading-wrapper', 'electric-wrapper', toggleForm.electricForm ? 'show-form' : 'hide-form']">
          <h3 class="section-title electric-title">Camión a batería eléctrica</h3>
          <input class="checkbox-input" type="checkbox" formControlName="electricForm" id="electric-checkbox">
          <span class="span-event-container" (click)="handleFormToggle('electricForm')">
            <span class="arrow-form"></span>
          </span>
        </div>

        <form class="electric-form truck-form" [formGroup]="electricTruckForm">

          <div class="truck-form-column">
            <h4>Camión</h4>
            <div class="entry">
              <label data-required for="e-gross-weight">Peso bruto</label>
              <div class="input-container">
                <input type="number" formControlName="eGrossWeight" id="e-gross-weight">
                <span class="suffix">ton</span>
              </div>
            </div>
            <div class="entry">
              <label data-required for="e-tare">Tara</label>
              <div class="input-container">
                <input type="number" formControlName="eTare" id="e-tare" required>
                <span class="suffix">ton</span>
              </div>
            </div>
            <div class="entry">
              <label [class.required]="!electricTruckForm.get('batterySwitch')?.value" for="battery">Batería</label>
              <div class="input-container">
                <input type="number" formControlName="battery" id="battery">
                <span class="suffix">kWh</span>
              </div>
              <div class="required-checkbox-container">
                <input type="checkbox" formControlName="batterySwitch" id="battery-switch">
                <label for="battery-switch">No disponible</label>
              </div>
            </div>
            <!--            <div class="entry">-->
            <!--              <label data-required for="truck-power">Potencia del camión</label>-->
            <!--              <div class="input-container">-->
            <!--                <input type="number" formControlName="truckPower" id="truck-power">-->
            <!--                <span class="suffix">kW</span>-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="entry">
              <!--              <input type="checkbox" formControlName="modelSelectionToggle" id="model-selection-toggle">-->
              <label for="model-selection">Modelo disponible en Uruguay</label>
              <!--            </div>-->
              <!--            <div class="entry disable-events">-->
              <div class="input-container">
                <div class="select">
                  <!--                              [class.disabled]="!electricTruckForm.get('modelSelectionToggle')?.value"-->
                  <select (change)="setTruckModel()" formControlName="modelSelection" id="model-selection">
                    <option *ngFor="let model of getTruckModels()"
                            value="{{model.brand}}-{{model.model}}">
                      {{model.brand}} {{model.model}}
                    </option>
                    <!--                    <option value="model-1">Modelo 1</option>-->
                    <!--                    <option value="model-2">Modelo 2</option>-->
                    <!--                    <option value="model-3">Modelo 3</option>-->
                    <!--                    <option value="model-4">Modelo 4</option>-->
                    <!--                    <option value="model-5">Modelo 5</option>-->
                  </select>
                </div>
              </div>
            </div>
          </div>


          <div class="truck-form-column">
            <h4>Operación</h4>
            <div class="entry">
              <label data-required for="ute-fare">Tarifa UTE</label>
              <div class="input-container">
                <div class="select">
                  <select formControlName="uteFare" id="ute-fare">
                    <option value="rs">RS</option>
                    <option value="gs">GS</option>
                    <option value="mc1">MC1</option>
                    <option value="mc2">MC2</option>
                    <option value="mc3">MC3</option>
                    <option value="gc1">GC1</option>
                    <option value="gc2">GC2</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="entry">
              <label data-required for="consumed-power">Potencia contratada</label>
              <div class="input-container">
                <input type="number" formControlName="consumedPower" id="consumed-power">
                <span class="suffix">kW</span>
              </div>
            </div>
            <div class="entry">
              <label data-required for="charging-schedule">Horario carga</label>
              <div class="input-container">
                <div class="select">
                  <select formControlName="chargingSchedule" id="charging-schedule">
                    <option value="valley">Valle</option>
                    <option value="flat">Llano</option>
                    <option value="peak">Punta</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="entry">
              <label data-required for="charging-time">Horas de carga necesarias</label>
              <div class="input-container">
                <input type="number" formControlName="chargingTime" id="charging-time">
                <span class="suffix">horas</span>
              </div>
            </div>

            <!--            <div class="entry">-->
            <!--              <div class="input-container">-->
            <!--                <input type="checkbox" formControlName="batteryReplacement" id="battery-replacement">-->
            <!--                <label data-required for="battery-replacement">Recambio de batería</label>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>

          <div class="truck-form-column">
            <h4>Economía</h4>
            <div class="entry">
              <label [class.required]="!electricTruckForm.get('eInsuranceCostSwitch')?.value" for="e-insurance-cost">Costo
                seguro</label>
              <div class="input-container">
                <input type="number" formControlName="eInsuranceCost" id="e-insurance-cost">
                <span class="suffix">$/año</span>
              </div>
              <div class="required-checkbox-container">
                <input type="checkbox" formControlName="eInsuranceCostSwitch" id="e-insurance-cost-switch">
                <label for="e-insurance-cost-switch">No disponible</label>
              </div>
            </div>
            <div class="entry">
              <label [class.required]="!electricTruckForm.get('eTruckPriceSwitch')?.value" for="e-truck-price">Precio
                camión</label>
              <div class="input-container">
                <input type="number" formControlName="eTruckPrice" id="e-truck-price">
                <span class="suffix">USD</span>
              </div>
              <div class="required-checkbox-container">
                <input type="checkbox" formControlName="eTruckPriceSwitch" id="e-truck-price-switch">
                <label for="e-truck-price-switch">No disponible</label>
              </div>
            </div>
            <div class="entry">
              <div class="input-container">
                <input type="checkbox" formControlName="comapDiscountSwitch" id="comap-discount-switch">
                <label for="comap-discount-switch">Descuento COMAP</label>
              </div>
            </div>
            <!--            <div class="entry">-->
            <!--              <label for="comap-investment">Inversión COMAP</label>-->
            <!--              <div class="input-container">-->
            <!--                <input [class.disabled]="!electricTruckForm.get('comapDiscountSwitch')?.value" type="number"-->
            <!--                       formControlName="comapInvestment" id="comap-investment">-->
            <!--                <span class="suffix">USD</span>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </form>
      </section>

      <section class="truck-section hydrogen-section">

        <div [ngClass]="['heading-wrapper', 'hydrogen-wrapper', toggleForm.hydrogenForm ? 'show-form' : 'hide-form']">
          <h3 class="section-title hydrogen-title">Camión a hidrógeno</h3>
          <input class="checkbox-input" type="checkbox" formControlName="hydrogenForm" id="hydrogen-checkbox">
          <span class="span-event-container" (click)="handleFormToggle('hydrogenForm')">
            <span class="arrow-form"></span>
          </span>
        </div>

        <form class="hydrogen-form truck-form" [formGroup]="hydrogenTruckForm">

          <div class="truck-form-column">
            <h4>Camión</h4>
            <div class="entry">
              <label data-required for="h-gross-weight">Peso bruto</label>
              <div class="input-container">
                <input type="number" formControlName="hGrossWeight" id="h-gross-weight">
                <span class="suffix">ton</span>
              </div>
            </div>
            <div class="entry">
              <label data-required for="h-tare">Tara</label>
              <div class="input-container">
                <input type="number" formControlName="hTare" id="h-tare" required>
                <span class="suffix">ton</span>
              </div>
            </div>
            <div class="entry">
              <label [class.required]="!hydrogenTruckForm.get('tankSizeSwitch')?.value" for="tank-size">Tamaño
                tanque</label>
              <div class="input-container">
                <input type="number" formControlName="tankSize" id="tank-size">
                <span class="suffix">kg</span>
              </div>
              <div class="required-checkbox-container">
                <input type="checkbox" formControlName="tankSizeSwitch" id="tank-size-available">
                <label for="tank-size-available">No disponible</label>
              </div>
            </div>
            <div class="entry">
              <label [class.required]="!hydrogenTruckForm.get('cellPowerSwitch')?.value" for="cell-power">Potencia de
                celda</label>
              <div class="input-container">
                <input type="number" formControlName="cellPower" id="cell-power">
                <span class="suffix">kW</span>
              </div>
              <div class="required-checkbox-container">
                <input type="checkbox" formControlName="cellPowerSwitch" id="cell-power-available">
                <label for="cell-power-available">No disponible</label>
              </div>
            </div>
          </div>


          <div class="truck-form-column">
            <h4>Operación</h4>
            <div class="entry">
              <label data-required for="hydrogen-cost">Costo hidrógeno</label>
              <div class="input-container">
                <input type="number" formControlName="hydrogenCost" id="hydrogen-cost">
                <span class="suffix">USD/kg</span>
              </div>
            </div>
            <div class="entry">
              <label [class.required]="!hydrogenTruckForm.get('hInsuranceCostSwitch')?.value" for="h-insurance-cost">Costo
                seguro</label>
              <div class="input-container">
                <input type="number" formControlName="hInsuranceCost" id="h-insurance-cost">
                <span class="suffix">$/año</span>
              </div>
              <div class="required-checkbox-container">
                <input type="checkbox" formControlName="hInsuranceCostSwitch" id="h-insurance-cost-switch">
                <label for="h-insurance-cost-switch">No disponible</label>
              </div>
            </div>
            <div class="entry">
              <label [class.required]="!hydrogenTruckForm.get('hTruckPriceSwitch')?.value"
                     for="h-truck-price">Precio camión</label>
              <div class="input-container">
                <input type="number" formControlName="hTruckPrice" id="h-truck-price">
                <span class="suffix">USD</span>
              </div>
              <div class="required-checkbox-container">
                <input type="checkbox" formControlName="hTruckPriceSwitch" id="h-truck-price-switch">
                <label for="h-truck-price-switch">No disponible</label>
              </div>
            </div>
          </div>

          <div class="truck-form-column">
            <h4>Datos adicionales</h4>
            <div class="entry">
              <div class="input-container">
                <input type="checkbox" formControlName="hComapDiscountSwitch" id="h-comap-discount-switch">
                <label for="h-comap-discount-switch">Descuento COMAP</label>
              </div>
            </div>
            <!--            <div class="entry">-->
            <!--              <label [class.required]="hydrogenTruckForm.get('hComapDiscountSwitch')?.value"-->
            <!--                     for="investment">Inversión</label>-->
            <!--              <div class="input-container">-->
            <!--                <input [class.disabled]="!hydrogenTruckForm.get('hComapDiscountSwitch')?.value" type="number"-->
            <!--                       formControlName="comapInvestment" id="investment">-->
            <!--                <span class="suffix">USD</span>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </form>
      </section>
    </form>
  </div>


  <div class="assumptions-form" *ngIf="currentSection === 'assumptions'">
    <!--    <form [formGroup]="assumptionsForm" (ngSubmit)="assumptionsOnSubmit('results')">-->
    <form [formGroup]="assumptionsForm">
      <div class="inputs-container">
        <label for="inflation">Inflación</label>
        <div class="assumptions-input-container">
          <input type="number" formControlName="inflation" id="inflation">
          <span class="assumptions-suffix">%</span>
        </div>
        <label for="gasoil">Gasoil S50</label>
        <div class="assumptions-input-container">
          <input type="number" formControlName="gasoil" id="gasoil">
          <span class="assumptions-suffix">%</span>
        </div>
        <label for="electricity">Electricidad</label>
        <div class="assumptions-input-container">
          <input type="number" formControlName="electricity" id="electricity">
          <span class="assumptions-suffix">%</span>
        </div>
      </div>
      <label for="discount-rate">
        <h4 class="assumptions-label-title">Tasa de descuento</h4>
        <p class="assumptions-label-description">Coste del capital que determina el valor actual de un pago futuro</p>
      </label>
      <div class="assumptions-input-container">
        <input type="number" formControlName="discountRate" id="discount-rate">
        <span class="assumptions-suffix">%</span>
      </div>
      <label for="h-upgrade-rate">
        <h4 class="assumptions-label-title">Tasa de mejora del hidrógeno</h4>
        <p class="assumptions-label-description">Porcentaje de mejora anual en la tecnología que impacta en los
          costos</p>
      </label>
      <div class="assumptions-input-container">
        <input type="number" formControlName="hUpgradeRate" id="h-upgrade-rate">
        <span class="assumptions-suffix">%</span>
      </div>
      <div class="inputs-container">
        <h3>Vidas útiles de los camiones</h3>
        <div class="fill-gap"></div>
        <label for="d-lifespan" class="right-align">Camión diésel</label>
        <div class="assumptions-input-container">
          <input type="number" formControlName="dLifespan" id="d-lifespan">
          <span class="assumptions-suffix">años</span>
        </div>
        <label for="e-lifespan" class="right-align">Camión eléctrico</label>
        <div class="assumptions-input-container">
          <input type="number" formControlName="eLifespan" id="e-lifespan">
          <span class="assumptions-suffix">años</span>
        </div>
        <label for="battery-time-warranty" class="right-align">Garantía batería</label>
        <div class="assumptions-input-container">
          <input type="number" formControlName="batteryTimeWarranty" id="battery-time-warranty">
          <span class="assumptions-suffix">años</span>
        </div>
        <label for="battery-distance-warranty" class="right-align">Garantía batería</label>
        <div class="assumptions-input-container">
          <input type="number" formControlName="batteryDistanceWarranty" id="battery-distance-warranty">
          <span class="assumptions-suffix">km</span>
        </div>
        <label for="battery-number-of-cycles" class="right-align">Ciclos totales de batería</label>
        <div class="assumptions-input-container">
          <input type="number" formControlName="batteryNumberOfCycles" id="battery-number-of-cycles">
        </div>
        <label for="charging-station-cost-per-kw" class="right-align">Puesto de carga costo kW</label>
        <div class="assumptions-input-container">
          <input type="number" formControlName="chargingStationCostPerKW" id="charging-station-cost-per-kw">
          <span class="assumptions-suffix">USD</span>
        </div>
        <label for="h-lifespan" class="right-align">Camión a hidrógeno</label>
        <div class="assumptions-input-container">
          <input type="number" formControlName="hLifespan" id="h-lifespan">
          <span class="assumptions-suffix">años</span>
        </div>
      </div>
      <label for="h-infrastructure-cost">Costo infraestructura de hidrogeno</label>
      <div class="assumptions-input-container">
        <input type="number" formControlName="hInfrastructureCost" id="h-infrastructure-cost" class="add-right-padding">
        <span class="assumptions-suffix">USD/kg</span>
      </div>
      <label for="peso-dollar-conv">Dólar estadounidense</label>
      <div class="assumptions-input-container">
        <input type="number" formControlName="pesoDollarConv" id="peso-dollar-conv" class="add-right-padding">
        <span class="assumptions-suffix">$/USD</span>
      </div>
    </form>
  </div>

  <div *ngIf="currentSection === 'results'" class="results-container">

    <form [formGroup]="resultsVariablesForm" (change)="onResultsFormChange()" class="variables-card">
      <div class="title-section">
        <h3>Variables</h3>
        <p>Aquí puedes modificar variables rápidamente para evaluar cómo cambian los costos. Si deseas cambiar otra
          variable que no aparezca aquí, vuelva a "DATOS".
        </p>
      </div>
      <div class="variables-section">
        <div class="slider-container">
          <label for="results-daily-distance" class="variable-label">km diarios promedio</label>
          <div class="range-wrap">
            <input type="range" id="results-daily-distance" (input)="setBubble($event.target)"
                   formControlName="dailyDistance" class="slider" min="0" max="350">
            <output class="output-bubble"></output>
          </div>
          <div class="range-values-container"><span>0</span><span>350</span></div>
        </div>

        <div class="slider-container">
          <label for="results-operating-days" class="variable-label">días operativos</label>
          <div class="range-wrap">
            <input type="range" id="results-operating-days" formControlName="operatingDays"
                   (input)="setBubble($event.target)" class="slider" min="0" max="365">
            <output class="output-bubble"></output>
          </div>
          <div class="range-values-container"><span>0</span><span>365</span></div>
        </div>

        <div class="slider-container">
          <label for="results-vehicle-change" class="variable-label">años de cambio de flota</label>
          <div class="range-wrap">
            <input type="range" id="results-vehicle-change" formControlName="vehicleChange"
                   (input)="setBubble($event.target)" class="slider" min="0" max="20">
            <output class="output-bubble"></output>
          </div>
          <div class="range-values-container"><span>0</span><span>20</span></div>
        </div>

        <div class="variable-container">
          <label for="results-charging-schedule" class="variable-label">horario de carga</label>
          <select id="results-charging-schedule" formControlName="chargingSchedule" class="results-select">
            <option value="valley">Valle</option>
            <option value="flat">Llano</option>
            <option value="peak">Punta</option>
          </select>
        </div>

        <div class="variable-container">
          <label for="results-peso-dollar-conv" class="variable-label">cotización dólar</label>
          <div class="results-input-group">
            <input type="number" id="results-peso-dollar-conv" formControlName="pesoDollarConv" class="results-input">
            <span class="results-input-suffix">$/USD</span>
          </div>
        </div>

        <div class="variable-container">
          <label for="results-gas-cost" class="variable-label">precio diésel</label>
          <div class="results-input-group">
            <input type="number" id="results-gas-cost" formControlName="gasCost" class="results-input">
            <span class="results-input-suffix">$/LT</span>
          </div>
        </div>
      </div>
    </form>

    <div class="tco-card">
      <h3 class="title-section">Resumen de Costos Totales de Propiedad</h3>
      <div class="content-section">
        <div class="tco-results-wrapper">
          <table class="tco-results-table"
                 *ngIf="truckSelectionForm.get('dieselForm')?.value && truckFormService.dieselTCO">
            <tr>
              <th></th>
              <th [ngClass]="{'diesel-title': value.key.includes('diesel'), 'electric-title': value.key.includes('electric'),
              'hydrogen-title': value.key.includes('hydrogen')}"
                  *ngFor="let value of truckSelectionForm.value | keyvalue: originalOrder | truckSelection">
                {{handleFormTitleMapping(value.key)}}
              </th>
            </tr>
            <tr *ngFor="let dieselTcoValue of truckFormService.dieselTCO | keyvalue: originalOrder | tcoValues">
              <td class="results-label">
                {{dieselTcoValue.value.mapping.label}}
              </td>
              <td [class.negative-mapping]="dieselTcoValue.value.mapping.mapValue(dieselTcoValue.value.value) < 0">
                {{dieselTcoValue.value.mapping.mapValue(dieselTcoValue.value.value) | toFixed}}
              </td>
              <td *ngIf="truckSelectionForm.get('electricForm')?.value && truckFormService.electricTCO"
                  [class.negative-mapping]="getTcoVal(truckFormService.electricTCO, dieselTcoValue.key, dieselTcoValue.value.mapping.mapValue) < 0">
                {{getTcoVal(truckFormService.electricTCO, dieselTcoValue.key, dieselTcoValue.value.mapping.mapValue) | toFixed}}
              </td>
              <td *ngIf="truckSelectionForm.get('hydrogenForm')?.value && truckFormService.hydrogenTCO"
                  [class.negative-mapping]="getTcoVal(truckFormService.hydrogenTCO, dieselTcoValue.key, dieselTcoValue.value.mapping.mapValue) < 0">
                {{getTcoVal(truckFormService.hydrogenTCO, dieselTcoValue.key, dieselTcoValue.value.mapping.mapValue) | toFixed}}
              </td>
            </tr>
            <tr class="total-result">
              <td class="results-label">TCO</td>
              <td *ngIf="truckSelectionForm.get('dieselForm')?.value && truckFormService.dieselTCO">
                {{truckFormService.dieselTCO.getTCO() | toFixed}}
              </td>
              <td *ngIf="truckSelectionForm.get('electricForm')?.value && truckFormService.electricTCO">
                {{truckFormService.electricTCO.getTCO() | toFixed}}
              </td>
              <td *ngIf="truckSelectionForm.get('hydrogenForm')?.value && truckFormService.hydrogenTCO">
                {{truckFormService.hydrogenTCO.getTCO() | toFixed}}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div class="tco-card">
      <h3 class="title-section">Costos Totales de Propiedad</h3>
      <div class="content-section">
        <div class="flex-container add-bottom-margin">
          <div class="flex-item chart-container" *ngIf="this.truckSelectionForm.get('dieselForm')?.value">
            <h4 class="chart-title diesel-chart-title">Camión diésel</h4>
            <canvas id="diesel-tco-doughnut-chart"></canvas>
          </div>
          <div class="flex-item chart-container" *ngIf="this.truckSelectionForm.get('electricForm')?.value">
            <h4 class="chart-title electric-chart-title">Camión eléctrico</h4>
            <canvas id="electric-tco-doughnut-chart"></canvas>
          </div>
          <div class="flex-item chart-container" *ngIf="this.truckSelectionForm.get('hydrogenForm')?.value">
            <h4 class="chart-title hydrogen-chart-title">Camión a hidrógeno</h4>
            <canvas id="hydrogen-tco-doughnut-chart"></canvas>
          </div>
        </div>

        <div class="flex-container">
          <div class="flex-item" *ngIf="this.truckSelectionForm.get('dieselForm')?.value">
            <canvas id="diesel-tco-bar-chart"></canvas>
          </div>
          <div class="flex-item" *ngIf="this.truckSelectionForm.get('electricForm')?.value">
            <canvas id="electric-tco-bar-chart"></canvas>
          </div>
          <div class="flex-item" *ngIf="this.truckSelectionForm.get('hydrogenForm')?.value">
            <canvas id="hydrogen-tco-bar-chart"></canvas>
          </div>
        </div>
      </div>
    </div>

    <div class="tco-card">
      <h3 class="title-section">Costos de propiedad anuales</h3>
      <div class="content-section">
        <div *ngIf="this.truckSelectionForm.get('dieselForm')?.value">
          <canvas id="diesel-annual-chart"></canvas>
        </div>
        <div *ngIf="this.truckSelectionForm.get('electricForm')?.value">
          <canvas id="electric-annual-chart"></canvas>
        </div>
        <div *ngIf="this.truckSelectionForm.get('hydrogenForm')?.value">
          <canvas id="hydrogen-annual-chart"></canvas>
        </div>
      </div>
    </div>

    <div class="tco-card">
      <h3 class="title-section">Costos totales de propiedad por categoría</h3>
      <div class="content-section">
        <div class="flex-container">
          <div class="flex-item" *ngIf="this.truckSelectionForm.get('dieselForm')?.value">
            <canvas id="diesel-category-chart"></canvas>
          </div>
          <div class="flex-item" *ngIf="this.truckSelectionForm.get('electricForm')?.value">
            <canvas id="electric-category-chart"></canvas>
          </div>
          <div class="flex-item" *ngIf="this.truckSelectionForm.get('hydrogenForm')?.value">
            <canvas id="hydrogen-category-chart"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="section-button-container">
    <button *ngIf="currentSection !== 'assumptions'" class="right-aligned-button" data-section-change-btn
            (click)="goToSection('assumptions', $event.target)">
      Revisar supuestos
    </button>
    <button *ngIf="currentSection !== 'results'" class="right-aligned-button" data-section-change-btn
            (click)="goToSection('results', $event.target)">
      Ver resultados
    </button>
    <button *ngIf="currentSection === 'results'" class="right-aligned-button" data-section-change-btn
            (click)="downloadReport()">
      Descargar Resultados
    </button>
  </div>
</div>

<div class="fill-space"></div>

<div class="screen-bottom-positioning">
  <div class="blue-horizontal-line"></div>
  <app-footer></app-footer>
</div>
